module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/B6uY7l/images/e9781439632208_cover.jpg?1684305910319",
      "alt": "This image is the cover for the book Statue of Liberty, Images of America"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Statue of Liberty, Images of America\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Feel the power of Lady Liberty!")])]), _c('br'), _c('p', [_c('i', [_vm._v("The Statue of Liberty")]), _vm._v(" is an awesome visual journey that begins with the fantastic proposal of a French professor to give the United States a monument to commemorate the Revolutionary War alliance between the 13 colonies and France. It documents the gift's taking symbolic form of the ancient goddess of liberty and its designation as the tallest metal statue in the world. Highlights include Liberty's construction history, her changing symbolism over the years, and her use in popular advertising and political activism. Her upraised arm has saluted scores of ships as they have passed by. See how her dignity has welcomed Americans returning home from foreign parts and has given hope to newcomers seeking a fresh beginning in the land of liberty.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Barry Moreno\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Author Barry Moreno works in the Museum Services Division at the Statue of Liberty National Monument. He is the author of Arcadia Publishing's Ellis Island and several other books, including The Statue of Liberty Encyclopedia and the Encyclopedia of Ellis Island.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0